import gbAntTable from "./src/gb-ant-table.vue";
const gbAntTableCompenet = function(Vue) {
  Vue.component(gbAntTable.name, gbAntTable);
};
export default gbAntTableCompenet;
